module.exports = __webpack_public_path__ + "img/location.1e86f39.svg";